/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Delete Payment Refund Button
 */
import { Button, App } from 'antd';
import { ButtonProps } from 'antd/lib';

import useUpdatePaymentReconciliation from 'hooks/payments/mutate/useUpdatePaymentReconciliation';
import { getRefundAllocationsPayload } from 'utils/payment/paymentAllocation';
import { formatAmount } from 'utils/accounts/allAccounts';

type IProps = {
	data: PatientPayment.IPaymentReconciliation;
	id: string;
};

const DeletePaymentRefund: React.FC<IProps & ButtonProps> = ({ id, data, ...rest }) => {
	const { modal } = App.useApp();
	const { mutateAsync } = useUpdatePaymentReconciliation(id);

	const handleClick = () => {
		const refundAmount = (data?.fhirResource as Fhir.PaymentReconciliation)?.returnedAmount?.value;
		modal.confirm({
			title: 'Delete Refund',
			width: 560,
			closable: true,
			content: (
				<>
					{`Are you sure you want to permanently delete this recorded refund of ${formatAmount(refundAmount ?? 0)}?`}
					<br />
					<br />
					{'This action cannot be undone.'}
				</>
			),
			okText: 'Delete',
			okButtonProps: { danger: true },
			cancelText: 'Cancel',
			onOk: async () => {
				await mutateAsync({
					modal: {
						allocations: getRefundAllocationsPayload(data?.allocations),
						fhirResource: {
							...(data.fhirResource as Fhir.PaymentReconciliation),
							returnedAmount: undefined,
							outcome: 'partial',
						},
					},
				});
			},
		});
	};
	return (
		<Button danger onClick={handleClick} {...rest}>
			{'Delete'}
		</Button>
	);
};

export default DeletePaymentRefund;
